import { Box, Typography } from "@mui/material";
import { ReactComponent as SupportImg } from "../static/Icons/support-graphic.svg";

const HelpSupport = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "70%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          mt: "10%",
        }}
      >
        <SupportImg style={{ width: "auto", height: "350px" }} />{" "}
        <Typography variant="body2" align="center" mt={2} color="#989898">
          If you are facing any issue or if you have any questions, kindly send
          an email to{" "}
        </Typography>
        <Typography
          variant="body2"
          align="center"
          fontWeight="bold"
          color="primary.main"
          component="a"
          href="mailto:support@themcp.cloud"
          sx={{ textDecoration: "none" }}
        >
          support@themcp.cloud
        </Typography>
      </Box>
    </Box>
  );
};

export default HelpSupport;
